import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/dashboard.css';
import '../css/inicioPortal.css';
import { temModulo } from '../../utils/acesso';

/**
 * Nova Home, exclusiva do fluxo multi-acesso (login/senha) — layout do
 * handoff "Portal GAM pra você" (banner de boas-vindas + links úteis),
 * dentro do mesmo bloco .dashboard > .dashboard-content > .dashboard-painel
 * usado por todas as outras telas (dados-cadastrais, financeiro, boletos...).
 * O fluxo antigo (token na URL) continua usando <Dashboard>, sem alteração.
 */
function InicioPortal({ cliente, modulosAtivos, souMaster }) {
    const navigate = useNavigate();

    const podeFinanceiro = temModulo(modulosAtivos, 'Financeiro');
    const podeSAC = temModulo(modulosAtivos, 'SAC');
    const podeDadosCadastrais = temModulo(modulosAtivos, 'Dados Cadastrais');

    return (
        <div className="dashboard">
            <div className="dashboard-content">
                <div className="dashboard-painel inicio-painel"> 

                    <div className="welcome-banner" data-screen-label="banner-boas-vindas">
                        <span className="wb-pill-badge"></span>
                        <h1 className="wb-title">Olá, {cliente?.razaoSocial || 'cliente GAM'}!</h1>
                        <p className="wb-desc">Seja bem-vindo(a) ao seu novo Portal GAM pra você.</p>

                        <div className="wb-nav">
                            <button className="wb-pill-btn is-active" style={{ '--wb-color': '#1B1F8A' }} onClick={() => navigate('/')}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></svg>
                                Início
                            </button>
                            {podeFinanceiro && (
                                <button className="wb-pill-btn" style={{ '--wb-color': '#3A2FB0' }} onClick={() => navigate('/boletos')}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2.5" y="6" width="19" height="13" rx="2" /><circle cx="12" cy="12.5" r="2" /></svg>
                                    Financeiro
                                </button>
                            )}
                            {podeSAC && (
                                <button className="wb-pill-btn" style={{ '--wb-color': '#1FB57A' }} onClick={() => navigate('/consulta-sac')}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.5 8.4 8.4 0 0 1-4-1L3 21l2-5.5a8.4 8.4 0 0 1-1-4 8.4 8.4 0 0 1 8.5-8.5 8.4 8.4 0 0 1 8.5 8.5z" /></svg>
                                    SAC
                                </button>
                            )}
                            {podeDadosCadastrais && (
                                <button className="wb-pill-btn" style={{ '--wb-color': '#1B1F8A' }} onClick={() => navigate('/dados-cadastrais')}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2.2" /><path d="M14 9h5M14 12h5M5 17h7" /></svg>
                                    Dados Cadastrais
                                </button>
                            )}
                            {souMaster && (
                                <button className="wb-pill-btn" style={{ '--wb-color': '#D9388C' }} onClick={() => navigate('/gestao-usuarios')}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="8" r="3.2" /><circle cx="17" cy="9.5" r="2.4" /><path d="M3 19c.8-2.8 3.2-4.6 6-4.6s5.2 1.8 6 4.6" /><path d="M15.5 14.5c2.4 0 4.4 1.4 5 4" /></svg>
                                    Usuários e Permissões
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="links-header">
                        <h2>Links Úteis para seu negócio!</h2>
                        <p>Atalhos para os serviços e canais oficiais da GAM.</p>
                    </div>
                    <div className="link-grid" data-screen-label="links-uteis">
                        <a className="link-card" href="https://www.egam.com.br" target="_blank" rel="noreferrer" style={{ '--accent': '#3A2FB0' }}>
                            <div className="link-icon eg">EG</div>
                            <h3>Comprar no eGAM</h3>
                            <p>Acesse nossa plataforma de e-commerce e faça seus pedidos com facilidade.</p>
                            <span className="access">Acessar <span className="arrow">→</span></span>
                        </a>
                        <a className="link-card" href="https://drive.google.com/drive/folders/1IU2eynvValse743K0s3re_Unjvt4xqxG" target="_blank" rel="noreferrer" style={{ '--accent': '#6B3FA0' }}>
                            <div className="link-icon df">DF</div>
                            <h3>Documentação farmácia</h3>
                            <p>Acesse documentos, guias e manuais importantes para sua operação.</p>
                            <span className="access">Acessar <span className="arrow">→</span></span>
                        </a>
                        <a className="link-card" href="https://www.youtube.com/@GAMdistribuidora" target="_blank" rel="noreferrer" style={{ '--accent': '#F0383B' }}>
                            <div className="link-icon yt">YT</div>
                            <h3>Youtube</h3>
                            <p>Assista nossos vídeos, tutoriais e novidades em nosso canal oficial.</p>
                            <span className="access">Acessar <span className="arrow">→</span></span>
                        </a>
                        <a className="link-card" href="https://www.instagram.com/gamdistribuidora" target="_blank" rel="noreferrer" style={{ '--accent': '#E63E7D' }}>
                            <div className="link-icon ig">IG</div>
                            <h3>Instagram</h3>
                            <p>Siga-nos no Instagram para acompanhar as últimas notícias e eventos.</p>
                            <span className="access">Acessar <span className="arrow">→</span></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InicioPortal;
